import { TcrComponent, h, createRef } from './component.js';
import { TcrMarkdownView } from './markdown-view.js';

class TcrMarkdownInput extends TcrComponent
{
    inputRef = createRef();

    constructor(props)
    {
        super(props);
    }

    render()
    {
        let value = this.props.value || '';

        let preview = (
            <TcrMarkdownView class="markdown-modal-preview" content={value} />
        );
        let editor = this.props.readonly ? null : (
            <textarea ref={this.inputRef} value={value} data-field={this.props.field} onInput={this.props.onInput} />
        );
        return [
            preview,
            editor,
        ];
    }
}

export { TcrMarkdownInput };
